export function initialize(gaTrackId) {
  window.dataLayer = window.dataLayer || [];
}

export function pushDataLayer(dl) {
  window.dataLayer.push(dl);
}



// WEBPACK FOOTER //
// ./analytics/index.js